import React from "react";
import renderModal from '../modals/renderModal';

// will replace with Modal component but wanted a modal to render on click
const BulkShareLinkModal: React.FunctionComponent = () => (
  <div className="modal-content-wrapper bulk-label-modal">
    <div className="modal-content-wrapper__header">
      <span aria-hidden="true" className="bff-label icon" />
      <h3 className="modal-title">{bfTranslate('Add to Share Link')}</h3>
    </div>
  </div>
);

const ModalComponent = renderModal(BulkShareLinkModal, 'BulkShareLinkModal');
export default ModalComponent;
